import { DvIconCellRendererParams } from '@devinco/ui/grid';
import { ValueFormatterParams } from 'ag-grid-community';

export default class VoltageUtils {
  static isYellowVoltage = (value: number): boolean => {
    return value > 2.5 && value < 2.6;
  };

  static isRedVoltage = (value: number | undefined): boolean => {
    return !!value && value <= 2.5;
  };

  static setCellColor = (
    value: number
  ): { background: string; 'justify-content': string; display: string } => {
    if (!value || value >= 2.6) {
      return this.getVoltageStyles();
    } else if (this.isYellowVoltage(value)) {
      return this.getVoltageStyles('var(--dv-bg-surface-warning-active)');
    } else if (this.isRedVoltage(value)) {
      return this.getVoltageStyles('var(--dv-bg-surface-danger-active)');
    }
    return this.getVoltageStyles();
  };

  static setInputFieldColor = (voltageValue: number): string => {
    if (voltageValue && voltageValue >= 2.6) {
      return '';
    } else if (voltageValue && this.isYellowVoltage(voltageValue)) {
      return 'var(--dv-bg-surface-warning-active)';
    } else if (this.isRedVoltage(voltageValue)) {
      return 'var(--dv-bg-surface-danger-active)';
    } else {
      return '';
    }
  };

  static setVoltageStatusIcon = (
    value: number | undefined
  ): DvIconCellRendererParams => {
    if (!value) {
      return { icon: '', color: '', value: false } as DvIconCellRendererParams;
    }
    if (value >= 2.6) {
      return { icon: '', color: '', value } as DvIconCellRendererParams;
    } else if (this.isYellowVoltage(value)) {
      return {
        icon: 'warning_filled',
        color: 'var(--warning700)',
        value: !!value,
      } as DvIconCellRendererParams;
    } else if (this.isRedVoltage(value)) {
      return {
        icon: 'error_filled',
        color: 'var(--error700)',
        value: !!value,
      } as DvIconCellRendererParams;
    } else {
      return { icon: '', color: '', value: false } as DvIconCellRendererParams;
    }
  };

  static voltageValueFormatter = (
    formatterParams: ValueFormatterParams
  ): string => {
    if (formatterParams.value) {
      const voltageValue = +formatterParams.value;
      const voltageValueWithDecimal = voltageValue.toFixed(2).toString();
      return voltageValueWithDecimal.replace('.', ',');
    } else {
      return '';
    }
  };

  private static getVoltageStyles = (
    backgroundParam: string = ''
  ): { background: string; 'justify-content': string; display: string } => {
    return {
      background: backgroundParam,
      'justify-content': 'flex-end',
      display: 'flex',
    };
  };
}
